const fleet = {
  tr: {
    fleet: { weekGridLabel: "Haftalık araç rezervasyon takvimi. Ok tuşlarıyla gezin, Enter ile rezervasyon başlat." },
    common: {
      pagination: { first: "İlk sayfa", last: "Son sayfa" },
    },
    cctv: {
      streamFailed: "Yayın alınamadı",
      retry: "Tekrar dene",
    },
    fleetUi: {
      tabs: {
        pending: "Onay bekleyen",
        upcoming: "Yaklaşan",
        past: "Geçmiş",
        closed: "İptal / Red",
        all: "Tümü",
        active: "Aktif",
        inactive: "Pasif",
      },
      filters: {
        search: "Araç, plaka, kişi veya açıklama ara...",
        searchVehicle: "Araç adı veya plaka ara...",
        allVehicles: "Tüm araçlar",
        vehicle: "Araç",
        from: "Başlangıç ≥",
        to: "Bitiş ≤",
        sort: "Sırala",
        role: "Rolüm",
        roleAll: "Hepsi",
        roleOwner: "Sahibi olduklarım",
        roleParticipant: "Katılımcı olduklarım",
        sortStartAsc: "Tarih (yakın → uzak)",
        sortStartDesc: "Tarih (uzak → yakın)",
        sortNameAsc: "Ad (A → Z)",
        sortPlateAsc: "Plaka (A → Z)",
      },
      emptyFiltered: "Bu görünümde rezervasyon yok.",
      emptyVehiclesFiltered: "Aramanıza uygun araç yok.",
      rejectConfirm: "Bu rezervasyon talebi reddedilsin mi?",
      approveDone: "Rezervasyon onaylandı.",
      rejectDone: "Rezervasyon reddedildi.",
      cancelDone: "Rezervasyon iptal edildi.",
      saved: "Kaydedildi.",
      retry: "Tekrar dene",
      ownerLabel: "Sahibi",
      participantBadge: "Katılımcı",
      today: "Bugün",
      jumpToDate: "Tarihe git",
      backToVehicles: "Araçlara dön",
      imageTooLarge: "Görsel 5 MB'tan büyük olamaz.",
      imageBadType: "Yalnızca JPEG, PNG veya WEBP yüklenebilir.",
      form: {
        endBeforeStart: "Bitiş, başlangıçtan sonra olmalıdır.",
        startInPast: "Başlangıç zamanı geçmişte.",
        clientConflict: "Dikkat: Bu aralık takvimde mevcut bir rezervasyonla çakışıyor.",
        quickDuration: "Süre",
        hours1: "1 sa",
        hours2: "2 sa",
        hours4: "4 sa",
        endOfDay: "Gün sonu",
        duration: "Süre: {{value}}",
      },
    },
  },
  en: {
    fleet: { weekGridLabel: "Weekly vehicle reservation calendar. Use arrow keys to move, Enter to start a reservation." },
    common: {
      pagination: { first: "First page", last: "Last page" },
    },
    cctv: {
      streamFailed: "Stream unavailable",
      retry: "Retry",
    },
    fleetUi: {
      tabs: {
        pending: "Pending",
        upcoming: "Upcoming",
        past: "Past",
        closed: "Cancelled / Rejected",
        all: "All",
        active: "Active",
        inactive: "Inactive",
      },
      filters: {
        search: "Search vehicle, plate, person or note...",
        searchVehicle: "Search vehicle name or plate...",
        allVehicles: "All vehicles",
        vehicle: "Vehicle",
        from: "Start ≥",
        to: "End ≤",
        sort: "Sort",
        role: "My role",
        roleAll: "All",
        roleOwner: "Owned by me",
        roleParticipant: "I'm a participant",
        sortStartAsc: "Date (soonest first)",
        sortStartDesc: "Date (latest first)",
        sortNameAsc: "Name (A → Z)",
        sortPlateAsc: "Plate (A → Z)",
      },
      emptyFiltered: "No reservations in this view.",
      emptyVehiclesFiltered: "No vehicles match your search.",
      rejectConfirm: "Reject this reservation request?",
      approveDone: "Reservation approved.",
      rejectDone: "Reservation rejected.",
      cancelDone: "Reservation cancelled.",
      saved: "Saved.",
      retry: "Retry",
      ownerLabel: "Owner",
      participantBadge: "Participant",
      today: "Today",
      jumpToDate: "Go to date",
      backToVehicles: "Back to vehicles",
      imageTooLarge: "Image cannot exceed 5 MB.",
      imageBadType: "Only JPEG, PNG or WEBP is allowed.",
      form: {
        endBeforeStart: "End must be after start.",
        startInPast: "Start time is in the past.",
        clientConflict: "Heads up: this range overlaps an existing reservation on the calendar.",
        quickDuration: "Duration",
        hours1: "1 h",
        hours2: "2 h",
        hours4: "4 h",
        endOfDay: "End of day",
        duration: "Duration: {{value}}",
      },
    },
  },
};

export default fleet;
